import type { ChangeEvent, FormEvent } from "react";
import React, { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";

import { env } from "~/env";

export const Route = createFileRoute("/_main/admin/importer/")({
  component: RouteComponent,
});

function RouteComponent() {
  const [file, setFile] = useState<File | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0];
    if (selectedFile) {
      setFile(selectedFile);
      setError(null); // Clear any previous errors
    }
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!file) {
      setError("Please select a file first");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(`${env.VITE_API_URL}/upload/companies`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log("File uploaded successfully", result);
      setError(null);
    } catch (err) {
      console.error("Upload error:", err);
      setError("Failed to upload the file");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input type="file" accept=".csv" onChange={handleFileChange} />
      <button type="submit" disabled={!file}>
        Upload
      </button>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </form>
  );
}
